import React from 'react'
import PropTypes from 'prop-types'

import * as QuizPhase from '../../../commons/QuizPhase'
import { QuizType } from '../../../commons/EditorStatus'
import { flatten } from '../../../commons/utils'
import Header from '../../components/molecules/Header/Header'
import ResultBadge, { QuizResult } from '../../components/molecules/ResultBadge/ResultBadge'
import Prepare from '../../components/organisms/Prepare/Prepare'
import Complete from '../../components/organisms/Complete/Complete'
import Question from '../../components/organisms/Question/Question'
import QuestionPrepare from '../../components/organisms/QuestionPrepare/QuestionPrepare'
import ErrorPopup from '../../components/molecules/ErrorPopup/ErrorPopup'
import ImagePreloader from '../../components/atoms/ImagePreloader/ImagePreloader'
import './PresentationalQuizPage.css'
import RankingResult from '../../components/organisms/RankingResult/RankingResult'

const PresentationalQuizPage = ({
  type,
  index,
  phase,
  name,
  time,
  resultName,
  resultRank,
  presentationRank,
  participantCount,
  title,
  answerChoiceId,
  question,
  questions,
  popupErrorMessage,
  isAnswerSending,
  answerCount,
  postAnswer
}) => {
  let header = (
    <React.Fragment>
      <Header title={title} participantCount={type === QuizType.FIRSTPAGE.value ? null : participantCount} />
      {phase === QuizPhase.RESULT && question ? (
        <div styleName="badge">
          <ResultBadge type={answerChoiceId === question.choicedId ? QuizResult.CORRECT : QuizResult.FAILURE} />
        </div>
      ) : null}
    </React.Fragment>
  )

  let contents
  if (type === QuizType.FIRSTPAGE.value) {
    contents = <Prepare />
  } else if (type === QuizType.RANKING.value) {
    contents = <QuestionPrepare>結果発表</QuestionPrepare>

    if (resultRank) {
      contents = <RankingResult name={resultName} rank={String(resultRank)} />
    } else if (name && resultName && name === resultName) {
      contents = <RankingResult name={name} rank={String(presentationRank)} />
    }
  } else if (type === QuizType.COMPLETE.value) {
    contents = <Complete />
  } else {
    if (!question) {
      return <div />
    }
    const questionProps = {
      question,
      phase,
      answerChoiceId,
      answerCount,
      postAnswer
    }
    // phaseによって出すcontentsを変更
    switch (phase) {
      case QuizPhase.PREPARE:
        contents = <QuestionPrepare>{`第${index + 1}問`}</QuestionPrepare>
        break
      case QuizPhase.IS_ANSWER:
        contents = <QuestionPrepare>答え</QuestionPrepare>
        break
      case QuizPhase.START:
        contents = (
          <Question {...questionProps} isEnabled={question.choicedId === null} time={time || question.limit_time} />
        )
        break
      case QuizPhase.QUESTION:
        contents = <Question {...questionProps} isEnabled={false} isHidden={true} />
        break
      default:
        contents = <Question {...questionProps} isEnabled={false} time={0} />
        break
    }
  }

  return (
    <div styleName="appContainer">
      <div styleName="container">
        <div styleName="header">{header}</div>
        <div styleName="main">{contents}</div>
        {popupErrorMessage ? <ErrorPopup /> : null}
        {isAnswerSending ? <div styleName="loading" /> : null}
        <ImagePreloader images={flatten(questions.map(question => question.choices.map(choice => choice.image)))} />
      </div>
    </div>
  )
}

PresentationalQuizPage.propTypes = {
  index: PropTypes.number.isRequired,
  phase: PropTypes.number,
  type: PropTypes.number.isRequired,
  name: PropTypes.string,
  time: PropTypes.number,
  resultName: PropTypes.string,
  resultRank: PropTypes.string,
  presentationRank: PropTypes.number,
  participantCount: PropTypes.number,
  answerChoiceId: PropTypes.number,
  question: PropTypes.object,
  questions: PropTypes.array,
  popupErrorMessage: PropTypes.string,
  isAnswerSending: PropTypes.bool.isRequired,
  title: PropTypes.string,
  answerCount: PropTypes.object,
  postAnswer: PropTypes.func.isRequired
}

export default PresentationalQuizPage
